import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BankConnection, WebForm } from '@ah-oh/fin-api';
import { ImportBankConnectionDto } from './dto/import-bank-connection.dto';
import { UpdateBankConnectionDto } from './dto/update-bank-connection.dto';

@Injectable({
    providedIn: 'root',
})
export class FinBankConnectionsService {
    private static readonly BASE_URL = environment.api + 'fin-api';

    constructor(private readonly http: HttpClient) {}

    findBanks(): Observable<BankConnection[]> {
        return this.http.get<BankConnection[]>(`${FinBankConnectionsService.BASE_URL}/bank-connections`);
    }

    create(dto: ImportBankConnectionDto): Observable<WebForm> {
        return this.http.put<WebForm>(`${FinBankConnectionsService.BASE_URL}/bank-connections`, dto);
    }

    update(dto: UpdateBankConnectionDto): Observable<Task> {
        return this.http.post<Task>(`${FinBankConnectionsService.BASE_URL}/bank-connections`, dto);
    }

    delete(id: number): Observable<any> {
        return this.http.delete<any>(`${FinBankConnectionsService.BASE_URL}/bank-connections/${id}`);
    }
}
